import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "download-banner flex"
}
const _hoisted_2 = { class: "download-content" }
const _hoisted_3 = { class: "star-list" }

import { storeToRefs } from 'pinia';
import { useHelpTool } from "@/hooks";
import { useSettingsStore } from '@/store'


export default {
  __name: 'DownloadBanner',
  setup(__props) {

const { openBrowser } = useHelpTool();
const settingsStore = useSettingsStore()
const { downloadPage, showDownloadBanner } = storeToRefs(settingsStore);

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_icon = _resolveComponent("van-icon")
  const _directive_audio = _resolveDirective("audio")

  return (_unref(showDownloadBanner))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_van_image, {
          class: "logo-img",
          src: require('@/assets/img/common/logo.png')
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "download-text" }, "SLOT MAX", -1)),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
              return _createVNode(_component_van_icon, {
                key: i,
                name: "star",
                color: "#FFB800"
              })
            }), 64))
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "download-btn",
          onClick: _cache[0] || (_cache[0] = $event => (_unref(openBrowser)(_unref(downloadPage))))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t('common.download').toUpperCase()), 1)
        ])), [
          [_directive_audio]
        ]),
        _withDirectives(_createVNode(_component_van_icon, {
          class: "close-icon",
          name: "clear",
          onClick: _cache[1] || (_cache[1] = $event => (_unref(settingsStore).hideDownloadBanner()))
        }, null, 512), [
          [_directive_audio, void 0, "close"]
        ])
      ]))
    : _createCommentVNode("", true)
}
}

}